let date = new Date();
export default {
    footer: '© 2011-' + date.getFullYear() + ' MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel',
}